import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { Message, MessageInfo } from '../models/message.model';

@Injectable({ providedIn: 'root' })
export class MessagesService extends AbstractService<Message> {

  getURLBase(): string {
    return '/messages'; // messages.trendmulti.com.br
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  override preCreate(obj: Message): void {
    delete obj?._id;
  }
  override preUpdate(obj: Message): void {
  }

  getMessageInfoByMessageId(messageId: string): Observable<MessageInfo> {
    return super.get(`/message-info/${messageId}`);
  }

}
